module.exports = __webpack_public_path__ + "static/media/WordsHavePower_p22-23.2fcae1fe.jpg";